// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GqRh2 {\n  /* Matches width and height of the other navigation elements. Ensures that badgeCount is aligned with Messages badgeCount */\n  margin: 7px;\n  width: var(--schoolinks-icon-lg);\n  height: var(--schoolinks-icon-lg);\n  position: relative;\n}\n\n.GqRh2 svg {\n  /* Aligns with other nav icon elements */\n  width: var(--schoolinks-icon-lg) !important;\n  height: var(--schoolinks-icon-lg) !important;\n  color: var(--color-white);\n}\n\n.A8qtw {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n}\n\n._3PCZ2 {\n  padding: unset;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popoverButton": "GqRh2",
	"badge": "A8qtw",
	"paper": "_3PCZ2"
};
export default ___CSS_LOADER_EXPORT___;
